// extracted by mini-css-extract-plugin
export var arrow = "_c0-2";
export var label = "_c0-1";
export var reminder = "_c0-0";